// extracted by mini-css-extract-plugin
export default {"wrapper":"page_wrapper__+wHtD","container":"page_container__Zdv1-","main":"page_main__nris0","header":"page_header__GKjgI","boxShadow":"page_boxShadow__hcPXi"};